module.exports = __webpack_public_path__ + "img/ameron.a3c41fa.png";